export default class SelectOption {
    constructor(id, value, text, isSelected) {
        this.id = id;
        this.value = value;
        this.text = text;
        this.selected = isSelected;
    }
}
